import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountContact } from 'common';
import { ApplicationPermissions, Permission } from '../../../models/application-permissions.model';

@Component({
  selector: 'acc-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
})
export class ContactsComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  tableData = new MatTableDataSource();
  tableColumns = ['firstName', 'phone', 'mobile', 'email', 'positionHeld', 'isRegulatoryContact', 'hasOnlineAccess', 'actions'];
  applicationPermissions: ApplicationPermissions;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.tableData.data = this.activatedRoute.snapshot.data.contacts;
    this.applicationPermissions = this.activatedRoute.snapshot.data.permissions;
    this.tableData.sort = this.sort;
    this.tableData.paginator = this.paginator;
    const savedPage = sessionStorage.getItem('contactsSavedPage');
    if (savedPage) {
      this.paginator.pageIndex = +savedPage;
      sessionStorage.removeItem('contactsSavedPage');
    }
  }

  showPermissions(contact: AccountContact) {
    return this.buildGrantedPermissionList(contact);
  }

  navigateToRemoveContact(contact: AccountContact) {
    sessionStorage.setItem('contactsSavedPage', this.paginator.pageIndex.toString());
    this.router.navigate([`/accounts/details/contacts/remove`], { state: { contactList: this.tableData.data, contact: contact } });
  }

  buildGrantedPermissionList(contact: AccountContact) {
    const allPermissions = this.applicationPermissions.groups.reduce((acc: Permission[], val) => acc.concat(val.permissions), []);
    let permissionsGranted = '';
    for (var permission of allPermissions) {
      if ((contact.accountPermissions & permission.permissionValue) === permission.permissionValue) {
        permissionsGranted += permission.permissionName + ' \u25AC ';
      }
    }
    return permissionsGranted.substring(0, permissionsGranted.length - 3);
  }
}
